
export const apiEndpoints = {

    applicationSettings: `/api/applicationsettings`,

    users: `/api/users`,
    users_id: `/api/users/:id`,
    users_id_settings: `/api/users/:id/settings`,
    users_id_initials: `/api/users/:id/initials`,
    users_id_roles: `/api/users/:id/roles`,
    users_id_roles_roleId: `/api/users/:id/roles/:roleId`,
    users_id_usercourses: `/api/users/:id/usercourses`,
    users_id_usercourses_courseId: `/api/users/:id/usercourses/:courseId`,
    users_id_usercourses_courseId_add: `/api/users/:id/usercourses/:courseId/add`,
    users_id_permissiongroup_permissionGroup: `/api/users/:id/permissiongroup/:permissionGroup`,
    users_id_individualpermissions: `/api/users/:id/individualpermissions`,
    users_request_passwordreset_siteId_email: `/api/users/request/passwordreset/:siteId/:email`,
    users_confirm_passwordreset_siteId_userId_requestId: `/api/users/confirm/passwordreset/:siteId/:userId/:requestId`,
    users_request_newemail_siteId_userId: `/api/users/request/newemail/:siteId/:userId`,
    users_confirm_newemail_siteId_userId_requestId: `/api/users/confirm/newemail/:siteId/:userId/:requestId`,
    users_request_createuser_siteId: `/api/users/request/createuser/:siteId`,
    users_confirm_createuser_siteId_userId_requestId: `/api/users/confirm/createuser/:siteId/:userId/:requestId`,
    users_id_changepassword: `/api/users/:id/changepassword`,
    users_id_adminupdateemail: `/api/users/:id/adminupdateemail`,
    users_id_adminupdatepassword: `/api/users/:id/adminupdatepassword`,
    users_introemail: `/api/users/introemail`,
    users_id_lastintroemail: `/api/users/:id/lastintroemail`,
    users_id_status: `/api/users/:id/status`,

    roles: `/api/roles`,

    // No api - have special proxies for development, but in production these are served directly
    files_privateFileName: '/files/:privateFileName',
    portalfiles_privateFileName: `/portalfiles/:privateFileName`, 

    incidents: `/api/incidents`,
    incidents_id: `/api/incidents/:id`,
    incidents_id_hidden: `/api/incidents/:id/hidden`,
    incidents_id_messages: `/api/incidents/:id/messages`,
    incidents_id_messages_siteId: `/api/incidents/:id/messages/:siteId`,
    incidents_type: `/api/incidents/:type`,

    portal_login_siteId_options:`/api/portal/login/:siteId/options`,
    portal_login_siteId_partner:`/api/portal/login/:siteId/partner`,
    portal_login_siteId_magicLink_request:`/api/portal/login/:siteIdOrLoginName/magic-link/request`,
    portal_login_siteId_magicLink_confirm:`/api/portal/login/:siteId/magic-link/confirm/:email/:requestId`,
    portal_access_key_siteId_accessKey: `/api/portal/access-key/:siteId/:accessKey`,
    portal_shared_resources: `/api/portal/shared-resources`,
    portal_shared_resources_type_id: `/api/portal/shared-resources/:resourceType/:resourceId`,

    site_siteId_partner:`/api/site/:siteId/partner`,

    amorgy_articles_id_versions_version_merge: `/api/amorgy/articles/:id/versions/:version/merge`
};